const prefix = "SYSTEM_LOG_";

export const EXPORT = prefix + "EXPORT";
export const LIST = prefix + "LIST";
export const LIST_NEXT_PAGE = prefix + "LIST_NEXT_PAGE";
export const LIST_PREVIOUS_PAGE = prefix + "LIST_PREVIOUS_PAGE";
